import { Button, Cell, FormControl, Grid, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { TextField } from 'components/form'
import { Form, FormRenderProps } from 'components/form/final-form/Form'
import { useCadastrarEnderecoEnvioMutation } from 'graphql/hooks.generated'
import { PedidoEnvio } from 'graphql/types.generated'
import React from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, required } from 'util/validation'

import { CancelarSolicitacaoEnvio } from './CancelarSolicitacaoEnvio'
import { EstadoCamposUnificacaoBase } from './ConfiguracoesUnificacaoBaseBox'

interface SolicitacaoEnvioFormProps {
  conexaoInternet: boolean
  setSolicitacaoId(solicitacaoId: string): void
  solicitacaoId: string
  estadoCamposForms: EstadoCamposUnificacaoBase
  setEstadoCamposForms(estadoCampos: EstadoCamposUnificacaoBase): void
  data: PedidoEnvio
}

export interface SolicitacaoEnvioModel {
  nomeInstalacao: string
  linkInstalacao: string
}

export const validator = createValidator<SolicitacaoEnvioModel>({
  nomeInstalacao: [required, maxLength(255)],
  linkInstalacao: [required, maxLength(255)],
})

export const SolicitacaoEnvioForm = (props: SolicitacaoEnvioFormProps) => {
  const [cadastrarPedidoEnvio] = useCadastrarEnderecoEnvioMutation()
  const path = metaPath<SolicitacaoEnvioModel>()
  const { conexaoInternet, setSolicitacaoId, solicitacaoId, estadoCamposForms, setEstadoCamposForms, data } = props
  const alert = useAlert()
  const initialValues = { nomeInstalacao: data?.nomeInstalacao, linkInstalacao: data?.linkInstalacao }

  const handleRejection = useErrorHandler()

  const onSubmit = (values: SolicitacaoEnvioModel) => {
    if (!conexaoInternet) {
      alert(
        'warning',
        'Não é possível solicitar a chave para envio sem conexão com a internet. Habilite a conexão ou tente novamente mais tarde.'
      )
    } else {
      cadastrarPedidoEnvio({
        variables: {
          input: { ...values },
        },
      })
        .then((result) => {
          setSolicitacaoId(result.data.cadastrarEnderecoEnvio.id)
          setEstadoCamposForms({ ...estadoCamposForms, isCampoSolicitacaoEnvioAtivo: false, isCampoSenhaAtivo: true })
        })
        .catch(handleRejection)
    }
  }

  const renderForm = (formProps: FormRenderProps<SolicitacaoEnvioModel>) => {
    return (
      <VFlow>
        <Grid gap={1}>
          <Cell size={5}>
            <h4>1. Solicitação de envio</h4>
          </Cell>
          <Cell size={7} />
          <Cell size={5}>
            <TextField
              label='Nome da minha instalação'
              required
              name={path.nomeInstalacao}
              maxLength={255}
              placeholder='Ex.: São Paulo, UBS da Trindade'
              disabled={!estadoCamposForms?.isCampoSolicitacaoEnvioAtivo}
            />
          </Cell>
          <Cell size={7} />
          <Cell size={4}>
            <TextField
              label='Link da instalação destino'
              required
              name={path.linkInstalacao}
              maxLength={255}
              disabled={!estadoCamposForms?.isCampoSolicitacaoEnvioAtivo}
            />
          </Cell>
          <Cell size={6}>
            <FormControl label={<span>&nbsp;</span>}>
              <Button
                size='small'
                kind='primary'
                onClick={formProps.handleSubmit}
                disabled={!estadoCamposForms?.isCampoSolicitacaoEnvioAtivo}
              >
                Solicitar
              </Button>
            </FormControl>
          </Cell>
          {!estadoCamposForms?.isCampoSolicitacaoEnvioAtivo && (
            <Cell size={6}>
              <CancelarSolicitacaoEnvio
                solicitacaoId={solicitacaoId}
                formSolicitarEnvio={formProps}
                setEstadoCamposForms={setEstadoCamposForms}
              />
            </Cell>
          )}
        </Grid>
      </VFlow>
    )
  }
  return (
    <Form<SolicitacaoEnvioModel>
      onSubmit={onSubmit}
      render={renderForm}
      validate={validator}
      initialValues={initialValues}
      {...props}
    />
  )
}
